import React from 'react';
import { Card, CardContent, CardHeader } from './ui/card';
import { Avatar, AvatarFallback, AvatarImage } from './ui/avatar';
import { Badge } from './ui/badge';
import { Star, Quote } from 'lucide-react';

const TestimonialCard = ({ testimonial }) => {
  return (
    <Card className="border-2 hover:border-cyan-400 transition-all duration-300 hover:shadow-xl h-full flex flex-col">
      <CardHeader>
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-center gap-4">
            <Avatar className="w-16 h-16 border-2 border-cyan-200">
              <AvatarImage src={testimonial.image} alt={testimonial.name} />
              <AvatarFallback>{testimonial.name.split(' ').map(n => n[0]).join('')}</AvatarFallback>
            </Avatar>
            <div>
              <h4 className="font-bold text-lg text-gray-900">{testimonial.name}</h4>
              <p className="text-sm text-gray-600">{testimonial.role}</p>
              <p className="text-xs text-gray-500">{testimonial.location}</p>
            </div>
          </div>
          <Quote className="h-8 w-8 text-cyan-200" />
        </div>

        {/* Rating */}
        <div className="flex items-center gap-1 mb-3">
          {[...Array(testimonial.rating)].map((_, i) => (
            <Star key={i} className="h-4 w-4 fill-yellow-400 text-yellow-400" />
          ))}
        </div>

        {/* Feature Badge */}
        <Badge className="bg-gradient-to-r from-cyan-100 to-teal-100 text-cyan-700 border-0 w-fit mb-3">
          {testimonial.feature}
        </Badge>
      </CardHeader>

      <CardContent className="flex-grow">
        <p className="text-gray-700 leading-relaxed italic">
          "{testimonial.text}"
        </p>
        <p className="text-xs text-gray-400 mt-4">{testimonial.date}</p>
      </CardContent>
    </Card>
  );
};

export default TestimonialCard;
